import { BarChart2, Globe, ShieldCheck, Sprout } from "lucide-react";
import { useMemo } from "react";
import { Button } from "randmarcomps";
import { Reseller as ApiReseller } from "randmar-api-client";
import LegacyReseller from "../../stores/reseller/Reseller";
import DownloadSalesReport from "../manufacturer/DownloadSalesReport";
import AddResellerToOpportunityWrapper from "./AddResellerToOpportunityWrapper";
import ManageQualificationWrapper from "./ManageQualificationWrapper";

interface IProps {
  reseller: LegacyReseller | ApiReseller;
}

const isLegacy = (r: LegacyReseller | ApiReseller): r is LegacyReseller => 'arEmail' in r;

const toApiReseller = (reseller: LegacyReseller | ApiReseller): ApiReseller => {
  if (!isLegacy(reseller)) {
    return reseller;
  }
  return {
    AREmail: reseller.arEmail,
    Address1: reseller.address1,
    Address2: reseller.address2,
    City: reseller.city,
    ContactName: reseller.contactName,
    CreationDate: reseller.createdDate,
    CreditLimit: reseller.creditLimit,
    DefaultWarehouse: reseller.defaultWarehouse,
    Website: reseller.website,
    Qualifications: reseller.isQualified ? [] : null,
    ResellerId: reseller.resellerId,
    Name: reseller.name,
    Phone: reseller.phone,
    PostalCode: reseller.postalCode,
    Province: reseller.province,
    Country: reseller.country,
  };
};

const ResellerActions = ({ reseller: rawReseller }: IProps) => {
  const reseller = useMemo(() => toApiReseller(rawReseller), [rawReseller]);

  return (
    <div className="w-full max-w-[250px] space-y-1 rounded-lg border bg-white p-2">
      <p className="px-2 pt-1 pb-2 text-xs font-semibold uppercase tracking-wide text-gray-600">
        Reseller
      </p>

      {reseller.Website &&
        <a
          className="flex w-full items-center rounded-md p-2 text-sm font-medium text-gray-800 no-underline hover:bg-gray-100"
          href={reseller.Website.substr(0, 4) === "http" ? `${reseller.Website}` : `//${reseller.Website}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Globe className="mr-2 h-4 w-4" />
          <span>Website</span>
        </a>
      }

      <DownloadSalesReport reseller={rawReseller}>
        <Button variant="ghost" className="h-auto w-full justify-start p-2 text-sm font-medium text-gray-800">
          <BarChart2 className="mr-2 h-4 w-4" />
          <span>Sales Report</span>
        </Button>
      </DownloadSalesReport>

      <hr className="my-1" />

      <p className="px-2 pt-1 pb-2 text-xs font-semibold uppercase tracking-wide text-gray-600">
        Qualification
      </p>

      <ManageQualificationWrapper reseller={rawReseller}>
        <Button variant="ghost" className="h-auto w-full justify-start p-2 text-sm font-medium text-gray-800">
          <ShieldCheck className="mr-2 h-4 w-4" />
          <span>Qualification Status</span>
        </Button>
      </ManageQualificationWrapper>

      <AddResellerToOpportunityWrapper reseller={rawReseller}>
        <Button variant="ghost" className="h-auto w-full justify-start p-2 text-sm font-medium text-gray-800">
          <Sprout className="mr-2 h-4 w-4" />
          <span>Add to Opportunity</span>
        </Button>
      </AddResellerToOpportunityWrapper>
    </div>
  );
}

export default ResellerActions;
